const indianNumberFormatterWithDecimal = (value) => {
  console.log(value, "value");
  return new Intl.NumberFormat("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value ?? 0);
};
export default indianNumberFormatterWithDecimal;
